import React, {useEffect, useState} from 'react';
import parse from 'html-react-parser';
import {useSelector} from 'react-redux';
import {
    currentZoomLevelState,
    mapDetailsBodyState
} from '../../../app/redux/retrievers/retrievers';
import {sendDataToParent} from "../../Map/base/functions/sendDataToParent";
import './mapDetails.css'
import {dragElement} from "../../../core/utils/drag-element.utils";

const MapDetailsBody = () => {
    const mapDetailsBody = useSelector(mapDetailsBodyState);
    const currentZoom = useSelector(currentZoomLevelState);

    useEffect(() => {
        const selectInput: any = document.getElementById('category-select')
        const handleChange = (e: any) => {
            const selectedValue: any = parseInt(e?.target?.value);
            sendDataToParent({type: 'mapDetails-piecesCategoryType', selectedValue});
        };

        selectInput.addEventListener('change', handleChange);
        selectInput && selectInput.addEventListener('mousedown', (e: any) => e.stopPropagation());

    }, [mapDetailsBody])

    useEffect(() => {
        const selectInput: any = document.getElementById('sort-select')

        if (currentZoom >= 12) {
            selectInput.disabled = true;
        } else {
            selectInput.disabled = false;
        }
        const handleChange = (e: any) => {

            const selectedValue: any = parseInt(e?.target?.value);
            sendDataToParent({type: 'mapDetails-filterType', selectedValue});
        };

        selectInput.addEventListener('change', handleChange);
        selectInput && selectInput.addEventListener('mousedown', (e: any) => e.stopPropagation());

    }, [mapDetailsBody])

    // useEffect(() => {
    //     const tableElement: any = document.getElementById('myTable');
    //     tableElement && tableElement.addEventListener('mousedown', (e: any) => e.stopPropagation());
    //     tableElement && tableElement.addEventListener('wheel', (e: any) => e.stopPropagation());
    //     tableElement && tableElement.addEventListener('mouseover', (e: any) => (e.target.style.cursor = 'default'));
    //
    // }, [mapDetailsBody]);

    useEffect(() => {
        const element = document.getElementById("wrapper");
        dragElement(element);
    }, []);

    return (
        <div className={'mapDetails-container'}>
            <div
                id="wrapper"
                className={'content'}
            >
                {parse(mapDetailsBody)}
            </div>
        </div>
    )

};

export default MapDetailsBody;
